import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { getModulePatients } from "../../../../api/area";
import qarbalNot from "../../../../assets/image/qarbalNot.png";
import TableQarbal from "../../table/tableQarbal";

export default function Qarbal({ dataArea }) {
  const [rowData, setRowData] = useState([]);
  const [rowDataQarbal, setRowDataQarbal] = useState([]);
  const [moduleName, setModuleName] = useState();
  const gridRef = useRef();

  // useEffect(() => {
  //   if (dataArea) {
  //     getModulePatients(dataArea[0]?.areas[0]?.id, "6662ff609e84295a4a4c3099")
  //       .then((x) => setRowData(x))
  //       .catch((z) => console.log(z));
  //   }
  // }, [dataArea]);
  // console.log(window.location.search.split("?", 3)[1].split("?", 2)[0]);
  useEffect(() => {
    if (dataArea) {
      getModulePatients(
        dataArea[0]?.areas[0]?.id,
        window.location.search.split("?", 3)[1].split("?", 2)[0],
        "?justRecepted=true"
      )
        .then((x) => {
          setRowData(x.patients);
          setModuleName(x.moduleName);
        })
        .catch((z) => console.log(z));
      getModulePatients(
        dataArea[0]?.areas[0]?.id,
        window.location.search.split("?", 3)[1].split("?", 2)[0],
        "?justUnRecepted=true"
      )
        .then((x) => {
          setRowDataQarbal(x.patients);
          setModuleName(x.moduleName);
        })
        .catch((z) => console.log(z));
    }
  }, [dataArea, window.location.search.split("?", 3)[1].split("?", 2)[0]]);
  const handlePatientClick = () => {
    getModulePatients(
      dataArea[0]?.areas[0]?.id,
      window.location.search.split("?", 3)[1].split("?", 2)[0],
      "?justRecepted=true"
    )
      .then((x) => setRowData(x.patients))
      .catch((z) => console.log(z));
    getModulePatients(
      dataArea[0]?.areas[0]?.id,
      window.location.search.split("?", 3)[1].split("?", 2)[0],
      "?justUnRecepted=true"
    )
      .then((x) => setRowDataQarbal(x.patients))
      .catch((z) => console.log(z));
  };
  // console.log(rowDataQarbal);
  // console.log(moduleName);
  return (
    <>
      <Typography
        mt="40px"
        //   onClick={() => setSelected(0)}
        className={"styleSelectedTab"}
      >
        {moduleName}
      </Typography>
      {rowDataQarbal?.length === 0 && rowData?.length === 0 ? (
        <Box
          height="70vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img src={qarbalNot} style={{ marginTop: "50px" }} />
        </Box>
      ) : (
        <>
          <TableQarbal
            moduleName={moduleName}
            handlePatientClick={handlePatientClick}
            gridRef={gridRef}
            children
            areaId={dataArea[0]?.areas[0]?.id}
            rowData={rowDataQarbal}
            setRowData={setRowDataQarbal}
            moduleId={window.location.search.split("?", 3)[1].split("?", 2)[0]}
          />
          <TableQarbal
            moduleName={moduleName}
            handlePatientClick={handlePatientClick}
            gridRef={gridRef}
            children
            isReception
            areaId={dataArea[0]?.areas[0]?.id}
            rowData={rowData}
            setRowData={setRowData}
            moduleId={window.location.search.split("?", 3)[1].split("?", 2)[0]}
          />
        </>
      )}
    </>
  );
}
